// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ProductCardFragmentDoc } from '../../layout/cards/ProductCard.generated';
export const ComponentCatalogueProductCarouselFragmentDoc = gql`
    fragment componentCatalogueProductCarousel on ComponentCatalogueProductCarousel {
  items {
    catalogueCode
    product {
      ...productCard
      ... on CatalogueEngagementRing {
        variationsByPrimaryMetal {
          ...productCard
        }
      }
      ... on CatalogueWeddingRing {
        variations {
          ...productCard
        }
      }
      ... on CatalogueJewelleryRing {
        variations {
          ...productCard
        }
      }
      ... on CatalogueJewelleryBracelet {
        variations {
          ...productCard
        }
      }
      ... on CatalogueJewelleryNecklace {
        variations {
          ...productCard
        }
      }
      ... on CatalogueJewelleryEarrings {
        variations {
          ...productCard
        }
      }
    }
  }
}
    ${ProductCardFragmentDoc}`;